import { StocksWalletExchangeCheckoutAction } from './stocks-wallet-exchange-checkout.action';
// import { createSelector } from '@ngrx/store';
// import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
// import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { InitializerAction } from '@toro/common/shared/state-management/initializer/initiliazer.action';

export class StocksWalletExchangeCheckoutState {
    public wallet: string;
    public amount: number;
    public action: string;
    public currentWallet: {};
}

export const initialState: StocksWalletExchangeCheckoutState = {
    wallet: null,
    amount: 0,
    action: null,
    currentWallet: null,
};

export function StocksWalletExchangeCheckoutReducer(
    state: StocksWalletExchangeCheckoutState = initialState,
    action?: StocksWalletExchangeCheckoutAction) {

    switch (action.type) {
        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolio:
            return { ...state, ...{ pending: true } };
        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolioError:
            return { ...state, ...{ pending: false } };
        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolioSuccess:
            return { ...state, ...{ pending: false } };

        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlug:
            return { ...state, ...{ pending: true } };
        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlugError:
            return { ...state, ...{ pending: false, error: action.payload } };
        case StocksWalletExchangeCheckoutAction.getInvestmentPortfolioBySlugSuccess:
            return { ...state, ...{ currentWallet: action.payload, pending: false } };

        case StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrder:
            return { ...state, ...{ pending: true } };
        case StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrderError:
            return { ...state, ...{ pending: false, error: action.payload } };
        case StocksWalletExchangeCheckoutAction.newInvestmentPortfolioOrderSuccess:
            return { ...state, ...{ order: action.payload, pending: false } };
        
            case InitializerAction.resetUserRelatedData:
            return initialState;
        default:
            return state;
    }
}
